"use client";

import React from "react";

import Link from "next/link";
import Image from "next/image";
import { useSession, signOut } from "next-auth/react";
import { usePathname } from "next/navigation";
import { useChat } from "@/context/ChatContext";

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuGroup,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useEffect, useState } from "react";
import { cn, getInitials } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { profilePopUpcourseMenus } from "../constans";
import { useGetNotificationsQuery } from "@/features/chats/chatApi";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import LogOutConfirmation from "@/components/partials/modal/log-out-confirmation";
import { useMediaQuery } from "usehooks-ts";

const Header = () => {
  const pathname = usePathname();
  const matches = useMediaQuery("(min-width: 768px)");

  const { notificationsList, setNotificationsList } = useChat();
  const { data: session, status }: { data: any; status: any } = useSession();
  const userData = session?.user;
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsImpersonating(localStorage.getItem("is_impersonating") === "true");
    }
  }, []);
  const { data: notificationsData } = useGetNotificationsQuery(true);
  const isActive = (href?: string) => {
    if (!href) return false;
    // Handle submenu items
    // if (href.startsWith("/support")) {
    //   return pathname.startsWith(href);
    // }
    if (href.startsWith("/chat")) {
      return pathname.startsWith(href);
    }
    return pathname === href;
  };
  useEffect(() => {
    if (notificationsData?.data?.notifications) {
      setNotificationsList(notificationsData?.data?.notifications || []);
    }
  }, [notificationsData, setNotificationsList]);

  return (
    <div className="bg-primary font-inter fixed top-0 left-0 z-50 w-full">
      <div className="relative container flex items-center justify-between py-4">
        <Link href={"/"} className="max-w-40 cursor-pointer lg:max-w-64">
          <Image
            src="/logo.png"
            alt="Company Logo"
            width={200}
            height={140}
            className="h-auto w-full"
            priority
            loading="eager"
          />
        </Link>

        {status === "loading" ? (
          <div className="flex items-center gap-2 py-2">
            <Skeleton className="size-8 rounded-full lg:size-10" />
            <Skeleton className="h-7 w-24 rounded-md lg:w-32" />
          </div>
        ) : (
          <div className="flex items-center gap-4">
            {isImpersonating && (
              <Button
                variant="destructive"
                onClick={async () => {
                  localStorage.removeItem("is_impersonating");
                  await signOut({ redirect: false });
                  const adminUrl = process.env.NEXT_PUBLIC_ADMIN_PANEL_BASE_URL;
                  window.location.href = `${adminUrl}/impersonate/stop`;
                }}
                className="flex items-center gap-2 rounded-full bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-red-700"
              >
                Stop Impersonating
              </Button>
            )}
            <DropdownMenu>
              <DropdownMenuTrigger asChild className="border-0! ring-0!">
                <Button
                  variant="ghost"
                  size="2xl"
                  className="dev text-white hover:bg-transparent hover:text-white"
                >
                  <Avatar className="size-8 lg:size-10">
                    <AvatarImage
                      src={userData?.avatar}
                      alt={userData?.name || "User Avatar"}
                    />
                    <AvatarFallback className="text-primary bg-white text-base font-medium lg:text-xl">
                      {getInitials(
                        userData?.name ||
                          (userData?.first_name &&
                            `${userData.first_name} ${userData.last_name}`)
                      )}
                    </AvatarFallback>
                  </Avatar>

                  <div className="flex flex-col items-start">
                    <span className="max-w-28 truncate text-sm font-semibold lg:max-w-full lg:text-lg">
                      {session?.user?.name}
                    </span>

                    <span className="text-xs font-normal text-slate-400">
                      {session?.user?.email}
                    </span>
                  </div>
                </Button>
              </DropdownMenuTrigger>

              <DropdownMenuContent
                className={cn("rounded-lg p-3 shadow-lg", {
                  "lg:w-[300px]": matches,
                  "w-[230px]": !matches,
                })}
                align="end"
              >
                {/* Profile Menus */}
                <DropdownMenuGroup>
                  {profilePopUpcourseMenus.map((menu) => {
                    // if (menu.items && menu.label.toLowerCase() === "support") {
                    //   // Handle Support as a submenu
                    //   return (
                    //     <DropdownMenuSub key={menu.id}>
                    //       <DropdownMenuSubTrigger
                    //         className={cn(
                    //           "group flex items-center gap-2 text-sm font-medium p-2 rounded-lg transition-colors duration-200 mb-1",
                    //           isActive(menu.href)
                    //             ? "!bg-blue-600 !text-white font-semibold"
                    //             : "text-slate-600 hover:bg-blue-100"
                    //         )}
                    //       >
                    //         {menu.icon &&
                    //           React.cloneElement(menu.icon, {
                    //             className: cn(
                    //               menu.icon.props.className,
                    //               "group-[.text-white]:text-white group-[.text-blue-600]:text-blue-600"
                    //             ),
                    //           })}
                    //         {menu.label}
                    //       </DropdownMenuSubTrigger>

                    //       {/* subdropdown */}
                    //       <DropdownMenuPortal>
                    //         <DropdownMenuSubContent
                    //           className={cn(
                    //             "w-[70px] lg:w-[200px] p-2 rounded-lg shadow-lg",
                    //             "bg-white text-slate-700"
                    //           )}
                    //           // {...offsets}
                    //         >
                    //           {menu.items.map((subMenu) => {
                    //             return (
                    //               <DropdownMenuItem
                    //                 asChild
                    //                 key={subMenu.id}
                    //                 className={cn(
                    //                   "group flex items-center gap-2 text-sm font-medium p-2 rounded-lg transition-colors duration-200 mb-1 last:mb-0",
                    //                   isActive(subMenu.href)
                    //                     ? "!bg-blue-600 !text-white font-semibold"
                    //                     : "text-slate-600 hover:bg-blue-100"
                    //                 )}
                    //               >
                    //                 <Link
                    //                   href={subMenu.href || "#"}
                    //                   className="flex items-center gap-2 w-full"
                    //                 >
                    //                   {/* Add group-[.text-white] to svg for active state */}
                    //                   {subMenu.icon &&
                    //                     React.cloneElement(subMenu.icon, {
                    //                       className: cn(
                    //                         subMenu.icon.props.className,
                    //                         "group-[.text-white]:text-white group-[.text-blue-600]:text-blue-600"
                    //                       ),
                    //                     })}
                    //                   {subMenu.label}
                    //                 </Link>
                    //               </DropdownMenuItem>
                    //             );
                    //           })}
                    //         </DropdownMenuSubContent>
                    //       </DropdownMenuPortal>
                    //     </DropdownMenuSub>
                    //   );
                    // }

                    return (
                      <DropdownMenuItem
                        key={menu.id}
                        className={cn(
                          "group mb-1 flex items-center gap-2 rounded-lg p-2 text-sm font-medium transition-colors duration-200 last:mb-0",
                          isActive(menu.href)
                            ? "bg-blue-600! font-semibold text-white!"
                            : "text-slate-600 hover:bg-blue-100"
                        )}
                        asChild
                      >
                        <Link
                          href={menu.href || "#"}
                          className="flex w-full items-center justify-between gap-2"
                        >
                          <div className="flex items-center gap-2">
                            <span>
                              {menu.icon &&
                                React.cloneElement(menu.icon, {
                                  className: cn(
                                    menu.icon.props.className,
                                    "group-[.text-white]:text-white group-[.text-blue-600]:text-blue-600"
                                  ),
                                })}
                            </span>
                            {menu.label}
                          </div>
                          {menu.href.includes("/chat") &&
                            notificationsList?.length > 0 && (
                              <div
                                className={`flex h-6 w-6 items-center justify-center rounded-md text-xs ${isActive(menu.href) ? "bg-white text-blue-600" : "bg-blue-600 text-white"}`}
                              >
                                {notificationsList?.length}
                                {notificationsList?.length > 9 && <sup>+</sup>}
                              </div>
                            )}
                        </Link>
                      </DropdownMenuItem>
                    );
                  })}
                </DropdownMenuGroup>

                <DropdownMenuSeparator />

                {/* Log out */}
                <DropdownMenuItem asChild className="p-0">
                  <LogOutConfirmation />
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
